export default __webpack_public_path__ + "static/images/list-4.b958be25.jpg";